export default __webpack_public_path__ + "static/media/icon_voucher_value.b52625cc.svg";